import { gql } from '@apollo/client';

export default gql`
  mutation deleteDocUpload($_id: String) {
    deleteDocUpload(_id: $_id) {
      ok
      message
      error
    }
  }
`;
